import { R, pipe } from "@mobily/ts-belt";
import { useRouteContext } from "@tanstack/react-router";
import { useGetOrganisationFromNameQuery } from "generated/graphql";
import { useAccessTokenStruct } from "../use-access-token";

export const useOrganisationFromDomain = () => {
  const accessToken = useAccessTokenStruct();
  const { subdomain } = useRouteContext({ from: "__root__" });
  const pause = subdomain == null || accessToken.data == null;
  const [{ data, fetching, error }] = useGetOrganisationFromNameQuery({
    variables: {
      organisationSubdomain: subdomain ?? "",
    },
    pause,
  });

  if (accessToken.loading || fetching) {
    return undefined;
  }

  if (accessToken.error != null || accessToken.data == null) {
    return R.Error(accessToken.error ?? new Error("No access token"));
  }
  if (error != null || data == null) {
    return R.Error(error ?? new Error("Query data not found"));
  }

  const site = data.org;
  if (site == null) {
    return R.Error(new Error("Org missing from query response"));
  }

  return R.Ok(site);
};

export const useOrganisationSettings = () =>
  pipe(
    useOrganisationFromDomain() ?? R.Error(new Error("loading")),
    R.match(
      ({ taxaInterpretationEnabled }) => ({
        taxaInterpretationEnabled,
      }),
      () => ({
        taxaInterpretationEnabled: false,
      }),
    ),
  );

export type OrganisationSettings = ReturnType<typeof useOrganisationSettings>;
